let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a4qjG")).then(() => parcelRequire('fEDpg'));